import { isString } from 'lodash-es';

export const getUserInitials = (firstName: string | undefined, lastName: string | undefined): Uppercase<string> => {
  if (isString(firstName) && isString(lastName)) {
    return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}` as Uppercase<string>;
  }

  return 'FL';
};
